<!--
    Add Calculator Component
    Simple calculator that adds two numbers
-->
<svelte:options customElement={{ tag: "add-calculator", shadow: "none" }} />

<script lang="ts">
    let firstNumber: number = $state(0);
    let secondNumber: number = $state(0);
    let result: number = $derived(firstNumber + secondNumber);

    function handleFirstInput(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        firstNumber = parseFloat(value) || 0;
    }

    function handleSecondInput(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        secondNumber = parseFloat(value) || 0;
    }
</script>

<div class="add-calculator">
    <div class="field">
        <label class="label" for="first-number">First Number</label>
        <div class="control">
            <input id="first-number" class="input" type="number" value={firstNumber} oninput={handleFirstInput} placeholder="Enter first number" />
        </div>
    </div>

    <div class="field">
        <label class="label" for="second-number">Second Number</label>
        <div class="control">
            <input id="second-number" class="input" type="number" value={secondNumber} oninput={handleSecondInput} placeholder="Enter second number" />
        </div>
    </div>

    <div class="field">
        <label class="label">Result</label>
        <div class="control">
            <p class="title is-4">{firstNumber} + {secondNumber} = {result}</p>
        </div>
    </div>
</div>

<style>
    .add-calculator {
        max-width: 400px;
        margin: 0 auto;
    }
</style>
